// extracted by mini-css-extract-plugin
export default {"contactPage":"special_contactPage__NTita","contactForm":"special_contactForm__iyXwM"};